import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import TopBar from 'src/components/molecules/TopBar';
import TopBarHomeButton from 'src/components/atoms/TopBarHomeButton';
import { CoachDataDB } from 'src/data/datatypes';
import { getAllCoaches } from 'src/services/DBService/DbService';
import { setCoachId } from 'src/store/globalStateSlice';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { createAndSaveEvent } from '../services/EventLoggingService/EventLoggingService';
import { APP_NAME } from 'src/constants';

export default function CoachPicker() {
    const [coaches, setCoaches] = useState<CoachDataDB[]>([]);
    const coachId = useAppSelector(state => state.globalState.user?.coachId);
    const config = useAppSelector(state => state.globalState.config);
    const user = useAppSelector(state => state.globalState.user);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const loadData = async () => {
            setCoaches(await getAllCoaches());
        };
        loadData();
    }, []);

    const pickCoach = (coach: CoachDataDB) => {
        dispatch(setCoachId(coach._id));
        createAndSaveEvent(user?.code, 'coach-picked', coach._id);
        navigate('/');
    };

    return (
        <div id="coach-picker" className="content coachpicker">
            <TopBar
                title={'Coach auswählen'}
                icon={'icon_coach.svg'}
                leftButtons={[<TopBarHomeButton />]}
            />
            <h1 className="page-title">Wähle Deinen Coach!</h1>
            <div className="content-container coach-picker-container-flex">
                <p>
                    Hier kannst Du Deinen Coach wählen, der Dich durch die App begleitet. Dein Coach wird immer mal wiederauftauchen und Dir wichtige Tipps und Hinweise mit auf den Weg geben.
                </p>
                <p>
                    Jeder Coach begleitet Dich auf seine Weise auf Deinem Weg durch die {config?.name || APP_NAME} App. Aber keine Sorge, es ist keine Entscheidung für immer – falls Dir Dein momentaner Coach doch nicht zusagt, kannst Du jederzeit wieder hierher zurückkommen und eine andere Auswahl treffen.
                </p>
                {coaches.map((coach, index) => {
                    let className = 'coachpicker-item';
                    if (coach._id === coachId) {
                        className += ' selected';
                    }
                    return <div className={className} onClick={() => pickCoach(coach)} key={index}>
                        <img src={require('../static/i-pregno/coaches/' + coach.imagePath)} />
                        <h2 className="title">{coach.name}</h2>
                        <p className="description">{coach.description}</p>
                    </div>;
                }
                )}
            </div>
        </div>
    );
}